import classesK from '../kalkulatori.module.css'
import InfoBar from '../redesign/components/InfoBar'
import { useState, useEffect } from 'react'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import { betkoPopupWithAction } from '../../utils/BetkoPopupModal'
import { areAllFieldsFilled } from '../../utils/calculationDataValidation'

const calculatorType = 'Statistika sudija'
const StatistikaSudija = () => {
  //States
  const [error, setError] = useState(false)
  const [showInputArea, setShowInputArea] = useState(true)
  const [data, setData] = useState({
    values: {
      judge: ['', ''],
      judgeStats: ['', '', '', ''],
    },
    results: ['', '', ''],
  })

  const allInputsFilled = areAllFieldsFilled(data.values)

  useEffect(() => {
    if (allInputsFilled) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [allInputsFilled])

  const [disabled, setDisabled] = useState(true)
  const toggleInputArea = () => {
    if (!showInputArea) {
      clearFields()
      setDisabled(true)
      return
    } else {
      calculateAverages()
    }
    setShowInputArea((prev) => !prev)
  }
  useEffect(() => {
    if (error) {
      betkoPopupWithAction(
        'Greška',
        'Molimo proverite da li su svi podaci ispravno uneti i ponovo pokušajte.'
      )
    }
  }, [error])
  const clearFields = () => {
    setData({
      values: {
        judge: ['', ''],
        judgeStats: ['', '', '', ''],
      },
      results: ['', '', ''],
    })
    setShowInputArea(true)
  }

  const calculateAverages = () => {
    const [matches, yellowCards, redCards, penalties] =
      data.values.judgeStats.map(Number)

    if (matches > 0 && yellowCards >= 0 && redCards >= 0 && penalties >= 0) {
      const avgYellowCards = yellowCards / matches
      const avgRedCards = redCards / matches
      const avgPenalties = penalties / matches
      setData((prev) => ({
        ...prev,
        results: [
          avgYellowCards.toFixed(2),
          avgRedCards.toFixed(2),
          avgPenalties.toFixed(2),
        ],
      }))
    }
  }

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={toggleInputArea} disabled={disabled}>
            {showInputArea ? 'Prikaži rezultate' : 'Unesi obračunske podatke'}
          </button>
        </div>

        {showInputArea && (
          <>
            <div className={classesK.sectionTitle}>Upiši ime sudije</div>
            <OddsCalculator
              field={'judge'}
              data={data.values}
              setData={setData}
              labelPrefix={[
                'Ime ili prezime sudije',
                'Na koje se takmičenje odnose podaci',
              ]}
              type={['text', 'text']}
              step={['', '']}
              min={['', '']}
              rows={2}
              setError={setError}
            />
            <div className={classesK.sectionTitle}>Upiši statistiku sudije</div>
            <OddsCalculator
              field={'judgeStats'}
              data={data.values}
              setData={setData}
              labelPrefix={[
                'Br. utakmica na kojima je sudio',
                'Broj dodeljenih žutih kartona',
                'Broj dodeljenih crvenih kartona',
                'Broj dosuđenih jedanaesteraca',
              ]}
              type={['number', 'number', 'number', 'number']}
              step={['1', '1', '1', '1']}
              min={['0', '0', '0', '0']}
              setError={setError}
              rows={4}
            />
          </>
        )}
        {!showInputArea && (
          <>
            <ResultsSection
              title={'Podaci o sudiji i takmičenju'}
              names={[
                'Ime ili prezime sudije',
                'Podaci se odnose na takmičenja',
              ]}
              results={[data.values.judge[0], data.values.judge[1]]}
            />
            <ResultsSection
              names={[
                'Prosek dodeljenih žutih kartona po utakmici',
                'Prosek dodeljenih crvenih kartona po utakmici',
                'Prosek dosuđenih jedanaesteraca po utakmici',
              ]}
              results={[
                Number(data.results[0]).toFixed(1),
                data.results[1]
                  ? `${Math.round(Number(data.results[1]) * 100)}%`
                  : '-',
                data.results[2]
                  ? `${Math.round(Number(data.results[2]) * 100)}%`
                  : '-',
              ]}
            />
          </>
        )}
      </div>
    </div>
  )
}
export default StatistikaSudija
